import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=4f0c3d84"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"
import style0 from "./Consent.vue?vue&type=style&index=0&id=4f0c3d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports